export default function Go_Functions_Returns () {
  return (
    <div>
      <h1>Go_Functions_Returns </h1>
      <p>Function Returns</p>
    </div>
  );
}